import type { JSX } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface ConfirmActionDialogProps {
  action: 'resetPassword' | 'deactivate' | null;
  email: string;
  fullName: string;
  onClose: () => void;
  onConfirm: () => void;
}

export function ConfirmActionDialog({
  action,
  email,
  fullName,
  onClose,
  onConfirm,
}: ConfirmActionDialogProps): JSX.Element {
  const title = action === 'resetPassword' ? 'Reset Password' : 'Deactivate Super Admin';
  const description =
    action === 'resetPassword'
      ? `Are you sure you want to send a password reset email to ${email}?`
      : `Are you sure you want to deactivate ${fullName}? They will no longer be able to access the system.`;

  return (
    <AlertDialog open={action !== null} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Confirm</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
